import { WorkbenchIcon } from '@owc-types/WorkbenchIcon.enum';

export enum SocialPlatform {
  facebook = WorkbenchIcon.Facebook,
  instagram = WorkbenchIcon.Instagram,
  linkedin = WorkbenchIcon.Linkedin,
  messenger = WorkbenchIcon.Messenger,
  pinterest = WorkbenchIcon.Pinterest,
  twitter = WorkbenchIcon.Twitter,
  vk = WorkbenchIcon.Vk,
  x = WorkbenchIcon.X,
  xing = WorkbenchIcon.Xing,
  youtube = WorkbenchIcon.Youtube,
}
